angular.module('admin.services').constant('RemovalReasons', {
   // Mapeamento de códigos para labels
   labels: {
      EXIT_FROM_COMPANY: 'Saída da Empresa',
      DEPARTMENT_CHANGE: 'Mudança de Departamento',
      USER_REPLACEMENT: 'Substituição de Usuário',
      ACCESS_CHANGE: 'Troca de Acesso',
      LICENSES_REDUCTION: 'Redução de Licenças',
   },

   // Função para obter o label de um código
   getLabel: function (code) {
      if (!code) return '-'
      return this.labels[code] || code
   },

   // Função para obter o código a partir de um label ou código
   getCode: function (value) {
      if (!value) return null

      // Se já for um código válido, retorna ele mesmo
      if (this.labels[value]) {
         return value
      }

      // Normaliza o valor para comparação (remove acentos, espaços extras, etc)
      var normalizedValue = String(value).toLowerCase().trim()

      // Tenta encontrar o código pelo label (comparação case-insensitive)
      for (var code in this.labels) {
         var normalizedLabel = String(this.labels[code]).toLowerCase().trim()
         if (normalizedLabel === normalizedValue) {
            return code
         }
      }

      // Mapeamento de variações comuns
      var variations = {
         'troca de departamento': 'DEPARTMENT_CHANGE',
         'mudança de departamento': 'DEPARTMENT_CHANGE',
         'saída da empresa': 'EXIT_FROM_COMPANY',
         'substituição de usuário': 'USER_REPLACEMENT',
         'troca de acesso': 'ACCESS_CHANGE',
         'redução de licenças': 'LICENSES_REDUCTION',
      }

      if (variations[normalizedValue]) {
         return variations[normalizedValue]
      }

      // Se não encontrar, retorna o valor original (pode ser um código não mapeado)
      return value
   },
})
